<template>
    <div class="entities-list">
        <div class="entities-list__header">
            <h1 class="entities-list__title">Бренды</h1>
        </div>

        <div class="table-container">
            <table class="entities-table">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Название</th>
                        <th>Рекламодатель</th>
                        <th>Кампании</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="brand in brands" :key="brand.id">
                        <td>{{ brand.hierarchical_number || brand.id }}</td>
                        <td>{{ brand.name }}</td>
                        <td>{{ brand.advertiser?.name || '—' }}</td>
                        <td>{{ brand.campaigns?.length || 0 }}</td>
                    </tr>
                    <tr v-if="brands.length === 0">
                        <td colspan="4" class="text-center text-muted">Нет брендов</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BrandsList',
    props: {
        brands: {
            type: Array,
            default: () => []
        },
        userData: {
            type: Object,
            required: true
        }
    }
};
</script>

<style lang="scss" scoped>
.entities-list {
    padding: 2rem;
    max-width: 1400px;
    margin: 0 auto;

    &__header {
        margin-bottom: 2rem;
    }

    &__title {
        font-size: 2rem;
        font-weight: 600;
        color: #0f172a;
        margin: 0;
    }
}

.table-container {
    background: white;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.entities-table {
    width: 100%;
    border-collapse: collapse;

    thead {
        background: #f8fafc;
    }

    th {
        padding: 1rem;
        text-align: left;
        font-weight: 600;
        color: #374151;
        border-bottom: 2px solid #e5e7eb;
    }

    td {
        padding: 1rem;
        border-bottom: 1px solid #e5e7eb;
        color: #1f2937;
    }

    tbody tr:hover {
        background: #f9fafb;
    }

    .text-center {
        text-align: center;
    }

    .text-muted {
        color: #9ca3af;
    }
}
</style>

